/*
课程课件组件 课程课件列表的展示 下载课件实现
courseInfo: 课程详情数据
*/

<template>
  <div class="down_courseware_list" v-loading="opts.loading">
    <div
      v-for="item in opts.coursewareList"
      class="down_menu_item"
    >
      <div class="down_item_name">
        <span
          class="iconfont icon-download mgr10"
          @click="handleDown(item)"
        />
        <div class="down_item_title tx-ov">
          {{ item.materialName }}
        </div>
      </div>
      <div class="down_item_status">
        {{ getSize(item.materialSize) }}
      </div>
    </div>
  </div>

</template>

<script>

import { useUserStore } from '@/stores/user'
import {
  courseApiListCourseware,
  courseListCourseware,
  coursewareDownloadApi,
  coursewareDownloadAuth,
  handleBeforeValid
} from '../../api/course'
import { getSize } from '../../utils'

export default {
  name: 'CourseNotes',
  components: {},
  props: {
    // 课程详情数据
    courseInfo: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  setup (props, { emit }) {
    const userStore = useUserStore()
    const { getToken } = userStore
    const route = useRoute()
    const router = useRouter()
    const token = computed(() => {
      return getToken()
    })
    const opts = reactive({
      coursewareList: [],
      loading: false
    })
    const { courseInfo } = toRefs(props)


    const getCourseware = () => {
      // 课件
      if (token.value) {
        opts.loading = true
        courseListCourseware({ id: courseInfo.value.id, coursewareType: true }).then((res) => {
          opts.loading = false
          opts.coursewareList = res || []
        }).catch(() => {
          opts.loading = false
        })
      } else {
        courseApiListCourseware({ id: courseInfo.value.id, coursewareType: true }).then((res) => {
          opts.loading = false
          opts.coursewareList = res || []
        }).catch(() => {
          opts.loading = false
        })
      }
    }


    const handleDown = (row) => {
      // 下载
      if (!handleBeforeValid(courseInfo.value)) {
        return false
      }
      if (!courseInfo.value.enableNotLoginWatch && !token.value) {
        router.push({
          path: '/login',
          query: {
            redirect: encodeURIComponent(route.fullPath)
          }
        })
        return false
      }
      getDwnUrl(row)
    }
    const getDwnUrl = async (row) => {
      let url = ''
      if (token.value) {
        url = await coursewareDownloadAuth({
          id: route.query.id,
          materialId: row.materialId
        })
      } else {
        url = await coursewareDownloadApi({
          id: route.query.id,
          materialId: row.materialId
        })
      }
      const link = document.createElement('a')
      link.href = url
      link.download = row.materialName
      link.click()
    }
    onMounted(() => {
      getCourseware()
    })
    return {
      opts,
      getSize,
      handleDown,
      courseInfo
    }
  }
}
</script>

<style scoped lang="scss">
.down_menu_item {
  display: flex;
  padding: 20px;
  justify-content: space-between;
  align-items: center;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #999999;
  border-bottom: 1px solid #ebeef5;

  .down_item_name {
    display: flex;
    align-items: center;
  }

  .iconfont {
    color: #333333;
    font-size: 24px;
  }
}

</style>
